import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {},
  title: {
    padding: theme.spacing(2),
  },
}));

export default useStyles;
